import React from 'react';
import { NavLink} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';

import { makeStyles } from '@material-ui/core/styles';
import { navigate } from './__data';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(5),
    background: 'transparent',
    boxShadow: 'none'
  },
  paperTitle: {
    padding: theme.spacing(4),
    background: 'transparent',
    boxShadow: 'none'
  },
  section: {
    paddingTop: '5rem',
    paddingBottom: '8rem',
    backgroundColor: 'white'
  }
}));

const Navigate = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        align="center"
        className={classes.section}
        component="section"
        container
        xs={12}
      >
        <Grid xs={12}>
          <Paper
            className={classes.paperTitle}
            component="header"
          >
            <Typography
              align="center"
              component="h2"
              variant="h1"
            >
              en savoir plus
            </Typography>
          </Paper>
        </Grid>
        {navigate.map((img, index) => {
          return (
            <Grid
              key={`navigate-${index}`}
              md={3}
              sm={6}
              xs={12}
            >
              <Paper
                align="center"
                className={classes.paper}
              >
                <NavLink
                  activeStyle={{
                    fontWeight: 'bold',
                    color: 'rgb(112, 195, 89)'
                  }}
                  style={{padding: 0, margin: 0, color: 'black'}}
                  to={img.link}
                >
                  <CardMedia
                    alt={img.alt}
                    component="img"
                    key={img.name}
                    src={img.src}
                    title={img.title}
                  />
                  <Typography
                    component="p"
                    style={{margin: '0.5rem'}}
                    variant="subtitle2"
                  >
                    Visiter la page
                  </Typography>
                  <Typography
                    component="a"
                    variant="h3"
                  >
                    {img.name}
                  </Typography>
                </NavLink>

              </Paper>
            </Grid>
          )
        })}
        <Grid
          container
          justify="center"
          xs={12}
        />
      </Grid>

    </>
  );
}

export default Navigate;
